import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { ILayoutStore } from '../../store/LayoutStore'
import Landscape from '../Landscape/Landscape'

interface ILayoutProps {
  LayoutStore?: ILayoutStore
}

@inject('LayoutStore')
@observer
class Layout extends React.Component<ILayoutProps> {
  public constructor(props: ILayoutProps) {
    super(props)
  }

  public render() {
    return (
      <div className={'App Layout '}>
        {this.props.children}

        <Landscape />
      </div>
    )
  }
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.tsx